/**
 * Default avatar helper — abstract geometric/gradient art for users who
 * haven't generated a real avatar yet. Replaces the legacy boring "AB"
 * initials placeholder everywhere in the app.
 *
 * We use dicebear `shapes` (pure abstract geometry — no faces, no people,
 * no copyrighted IP) keyed by username so each user gets a stable, unique
 * gradient that matches ZenScroll's teal / aurora aesthetic.
 *
 * Backend mirror lives in `routers/onboarding.py::_fallback_avatar_url`.
 *
 * Usage:
 *   import { defaultAvatar } from '@/lib/defaultAvatar';
 *   <img src={user.avatar_url || defaultAvatar(user.username)} />
 */

const BRAND_COLORS = ['1C4749', '5EEAD4', 'F4F4F0', 'DDA15E'];

export function defaultAvatar(seed) {
  const s = encodeURIComponent(String(seed || 'zenscroll'));
  const bg = BRAND_COLORS.join(',');
  return `https://api.dicebear.com/7.x/shapes/svg?seed=${s}&backgroundColor=${bg}&backgroundType=gradientLinear`;
}

export function avatarFor(user) {
  // Accepts either a full user object or a username string.
  if (!user) return defaultAvatar('zenscroll');
  if (typeof user === 'string') return defaultAvatar(user);
  return user.avatar_url || defaultAvatar(user.username || user.display_name || user.id || 'zenscroll');
}
